<button
  type="button"
  [class]="rootClasses"
  [attr.aria-pressed]="selected"
  [attr.aria-disabled]="disabled ? 'true' : null"
  [disabled]="disabled"
  (click)="toggle()"
>
  <mat-icon
    *ngIf="resolvedIcon"
    class="munily-filter-chip__icon"
    [ngClass]="iconSet"
    aria-hidden="true"
  >{{ resolvedIcon }}</mat-icon>
  <span class="munily-filter-chip__label">{{ label }}</span>
</button>
